export default "/_next/static/assets/icons/apple/apple-touch-icon-180x180.cb0171e899b4cd694c6906319c17c7af.png";